gx-designer-tool-bar {
  display: flex;
  pointer-events: all;
  color: var(--color-text-neutral-default); // WA: Force netural text color

  & .bar {
    display: flex;
    align-items: center;
    background-color: var(--color-accent-surface-elevation-1);
    padding-inline: var(--spacing-padding-s);
    min-height: 24px;
    & > .drag[hidden] + .identity {
      margin-left: 5px;
    }
    & > .identity {
      margin-right: 5px;
    }
    & > .buttons {
      display: flex;
      margin: 0;
      margin-left: 35px;
      padding: 0;
      list-style: none;
      & > li {
        display: flex;
        align-items: center;
        margin-right: 5px;
        &:last-child {
          margin-right: 0px;
        }
      }
      & > .select {
        position: relative;
        & gx-designer-tool-breadcrumb,
        & .gx-designer-tool-breadcrumb {
          position: absolute;
          &.location-top {
            right: 0px;
            bottom: 100%;
            padding-bottom: var(--spacing-padding-s);
            margin-right: calc(var(--spacing-padding-s) * -1);
          }
          &.location-bottom {
            right: 0px;
            top: 100%;
            padding-top: var(--spacing-padding-s);
            margin-right: calc(var(--spacing-padding-s) * -1);
          }
        }
        &:not(:hover) > gx-designer-tool-breadcrumb {
          visibility: hidden;
        }
      }
    }
  }
  & .arrow {
    width: 10px;
    height: 10px;
  }
  &.location-outside-top {
    flex-direction: column;
    & .bar {
      order: 1;
    }
    & .arrow {
      order: 2;
      background-image: linear-gradient(
        135deg,
        var(--color-accent-surface-elevation-1),
        var(--color-accent-surface-elevation-1) 50%,
        transparent 50%,
        transparent
      );
    }
  }
  &.location-outside-right {
    flex-direction: row;
    & .bar {
      order: 2;
    }
    & .arrow {
      order: 1;
      background-image: linear-gradient(
        -135deg,
        var(--color-accent-surface-elevation-1),
        var(--color-accent-surface-elevation-1) 50%,
        transparent 50%,
        transparent
      );
    }
  }
  &.location-outside-bottom {
    flex-direction: column;
    & .bar {
      order: 2;
    }
    & .arrow {
      order: 1;
      background-image: linear-gradient(
        45deg,
        var(--color-accent-surface-elevation-1),
        var(--color-accent-surface-elevation-1) 50%,
        transparent 50%,
        transparent
      );
    }
  }
  &.location-outside-left {
    flex-direction: row;
    & .bar {
      order: 1;
    }
    & .arrow {
      order: 2;
      background-image: linear-gradient(
        135deg,
        var(--color-accent-surface-elevation-1),
        var(--color-accent-surface-elevation-1) 50%,
        transparent 50%,
        transparent
      );
    }
  }
  &.location-inside-sticky {
    flex-direction: column;
    & .bar {
      order: 2;
    }
    & .arrow {
      order: 1;
      background-image: linear-gradient(
        45deg,
        var(--color-accent-surface-elevation-1),
        var(--color-accent-surface-elevation-1) 50%,
        transparent 50%,
        transparent
      );
    }
  }
  &.location-viewport-top {
    flex-direction: row;
    & .bar {
      order: 1;
    }
    & .arrow {
      display: none;
    }
  }
}

.gx-designer-tool-arrange-container {
  & .gx-designer-tool-bar {
    &.location-inside-sticky {
      max-width: unset !important;
    }
  }
}
